import React from "react";
import PageHeader from "../PageHeader/PageHeader";
import classes from "./Skills.module.css";
import codeThinking from "../../img/codeThinking.svg";
import {
  FaHtml5,
  FaCss3Alt,
  FaBootstrap,
  FaReact,
  FaNodeJs,
} from "react-icons/fa";
import { IoLogoJavascript } from "react-icons/io";
import {
  SiTailwindcss,
  SiRedux,
  SiExpress,
  SiPostman,
  SiMongodb,
  SiGithub,
} from "react-icons/si";
import { DiGit } from "react-icons/di";

const skills = [
  <FaHtml5 color="white" size="30" title="HTML" />,
  <FaCss3Alt color="white" size="30" title="CSS" />,
  <IoLogoJavascript color="white" size="30" title="Javascript" />,
  <FaReact color="white" size="30" title="React" />,
  <SiRedux color="white" size="30" title="Redux" />,
  <FaBootstrap color="white" size="30" title="Bootstrap" />,
  <SiTailwindcss color="white" size="30" title="Tailwind CSS" />,
  <FaNodeJs color="white" size="30" title="Node" />,
  <SiExpress color="white" size="30" title="Express" />,
  <SiMongodb color="white" size="30" title="MongoDb" />,
  <SiPostman color="white" size="30" title="Postman" />,
  <SiGithub color="white" size="30" title="Github" />,
  <DiGit color="white" size="30" title="Git" />,
];

function Skills() {
  return (
    <div className={classes.Skills} id="skills">
      <PageHeader title={"Skills"} />
      <p>
        I'm a life long learner and enjoy learning new stuff!Below are some
        programming languages, toolkits, frameworks and libraries that I worked
        with and like.Some of them I control better than the other.
      </p>

      <div className={classes.Container}>
        <div className={classes.codeThinking}>
          <img src={codeThinking} alt="codeThinking"></img>
        </div>
        <div className={classes.ListDiv}>
          {skills.map((e, i) => {
            return (
              <div className={classes.SkillCardDive} key={i}>
                {e}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Skills;
